import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuBarComponent } from "../../core/components/menu-bar/menu-bar.component";
import { ImageCarouselComponent } from "../../core/components/image-carousel/image-carousel.component";
import { FooterComponent } from "../../core/components/footer/footer.component";
import { Project } from '../../core/interfaces/Project';
import { combineLatest } from 'rxjs';
import { BackendService } from '../../core/services/backend.service';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'app-projects',
  imports: [MenuBarComponent, ImageCarouselComponent, FooterComponent, NgxTolgeeModule],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss'
})
export class ProjectsComponent {

  carouselItems: Project[] = [];
  project: Project | undefined;

  constructor(private route: ActivatedRoute, private router: Router, private backendService: BackendService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    combineLatest([
      this.backendService.getProjects(),
      this.route.paramMap
    ]).subscribe(([items, params]) => {
      const fetchedProjects : Project[] = items.data;
      const slug = params.get('slug');
      this.project = fetchedProjects.find(item => item.title === slug);
      window.scrollTo({ top: 0, behavior: 'instant' });
      //set carouselItems except the current project
      this.carouselItems = fetchedProjects.filter(item => item.title !== slug);
    });
  }
}
